import statusColorsCss from './statusColorsCss';

export const statusColors = [
	{
		value: 'pink',
		label: 'Pink',
		bgColor: 'bg-pink-100',
		textColor: 'text-pink-700',
	},
	{
		value: 'fuchsia',
		label: 'Fuchsia',
		bgColor: 'bg-pink-200',
		textColor: 'text-pink-700',
	},
	{
		value: 'brightPurple',
		label: 'Bright Purple',
		bgColor: 'bg-purple-100',
		textColor: 'text-purple-600',
	},
	{
		value: 'darkPurple',
		label: 'Dark Purple',
		bgColor: 'bg-indigo-200',
		textColor: 'text-indigo-800',
	},
	{
		value: 'darkBlue',
		label: 'Dark Blue',
		bgColor: 'bg-blue-100',
		textColor: 'text-blue-700',
	},
	{
		value: 'brightBlue',
		label: 'Bright Blue',
		bgColor: 'bg-cyan-100',
		textColor: 'text-cyan-800',
	},
	{
		value: 'darkGreen',
		label: 'Dark Green',
		bgColor: 'bg-teal-200',
		textColor: 'text-teal-800',
	},
	{
		value: 'brightGreen',
		label: 'Bright Green',
		bgColor: 'bg-teal-100',
		textColor: 'text-teal-800',
	},
	{
		value: 'oliveGreen',
		label: 'Olive Green',
		bgColor: 'bg-green-100',
		textColor: 'text-green-800',
	},
	{
		value: 'brightYellow',
		label: 'Bright Yellow',
		bgColor: 'bg-yellow-200',
		textColor: 'text-yellow-900',
	},
	{
		value: 'gold',
		label: 'Gold',
		bgColor: 'bg-yellow-100',
		textColor: 'text-yellow-700',
	},
	{
		value: 'darkOrange',
		label: 'Dark Orange',
		bgColor: 'bg-orange-200',
		textColor: 'text-orange-800',
	},
	{
		value: 'brightOrange',
		label: 'Bright Orange',
		bgColor: 'bg-orange-100',
		textColor: 'text-orange-700',
	},
	{
		value: 'brightRed',
		label: 'Bright Red',
		bgColor: 'bg-red-100',
		textColor: 'text-red-500',
	},
	{
		value: 'gray',
		label: 'Gray',
		bgColor: 'bg-200',
		textColor: 'text-900',
	},
];

export const statusTypes = [
	{ value: 'new', label: 'New' },
	{ value: 'info', label: 'Info' },
	{ value: 'active', label: 'Active' },
	{ value: 'success', label: 'Success' },
	{ value: 'pending', label: 'Pending' },
	{ value: 'inactive', label: 'Inactive' },
	{ value: 'warning', label: 'Warning' },
	{ value: 'danger', label: 'Danger' },
];

export const statusActionsPlans = [
	{ value: 'baySeller', label: 'BAY Seller Action Plan' },
	{ value: 'buyerChecklist', label: 'Buyer Checklist' },
	{ value: 'buyerOpenEscrow', label: 'Buyer Open Escrow' },
	{ value: 'ccActionPlan', label: 'CC Action Plan' },
	{ value: 'newListingChecklist', label: 'New Listing Checklist' },
	{ value: 'bayBuyer', label: 'BAY Buyer Action Plan' },
];

export const status_options  = [
	{ key: 'status', label: 'Active', value: 'Active', bg: statusColorsCss['olive'].bg, color: statusColorsCss['olive'].color },
	{ key: 'status', label: 'Coming Soon', value: 'Coming Soon', bg: statusColorsCss['neutral'].bg, color: statusColorsCss['neutral'].color },
	{ key: 'status', label: 'Under Contract', value: 'Under Contract', bg: statusColorsCss['pending'].bg, color: statusColorsCss['pending'].color },
	{ key: 'status', label: 'Pending', value: 'Pending', bg: statusColorsCss['pending'].bg, color: statusColorsCss['pending'].color },
	{ key: 'status', label: 'Off Market', value: 'Off Market', bg: statusColorsCss['info'].bg, color: statusColorsCss['info'].color },
	{ key: 'status', label: 'Sold', value: 'Sold', bg: statusColorsCss['sold'].bg, color: statusColorsCss['sold'].color },
	{ key: 'status', label: 'Rental', value: 'Rental', bg: statusColorsCss['active'].bg, color: statusColorsCss['active'].color },
	{ key: 'status', label: 'Leased', value: 'Leased', bg: statusColorsCss['new'].bg, color: statusColorsCss['new'].color },
	{ key: 'status', label: 'Expired', value: 'Expired', bg: statusColorsCss['inactive'].bg, color: statusColorsCss['inactive'].color },
	{ key: 'status', label: 'Canceled', value: 'Canceled', bg: statusColorsCss['inactive'].bg, color: statusColorsCss['inactive'].color },
	{ key: 'status', label: 'Withdrawn', value: 'Withdrawn', bg: statusColorsCss['inactive'].bg, color: statusColorsCss['inactive'].color },
];
